import * as indexingEndPoints from "../constants/endpoints/indexing";
import axios from "../axios/axios";

export const searchSkuName = (q) => {
  return axios({
    url: indexingEndPoints.SEARCH_SKU_NAME,
    method: "GET",
    params: {
      searchTerm: q,
    },
  });
};
